import { Plugins } from "@capacitor/core";
const { Device } = Plugins
import { config } from "../../config";
import axios from "axios";
import moment from "moment";

import { LocalStorage } from '@/data/localstorage';
import { BaseService } from '../base';
import { StationTransformer } from '../transformers/evcstation';
import { EVCStationReservationService } from "../../service/evcstation/reservation.service";

export class HolidayService extends BaseService {

    async getStationHolidayWorkDet(selectedStateCode: any) {
        let response = await axios.post(config.api.host + "/stationHolidayWorkDet", selectedStateCode, 
        {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        });
        return Promise.resolve(response.data.data);
    }

    async checkReservationForSelectedDate(selectedDate: any): Promise<void> {
        try {
            let response = await axios.post(config.api.host + "/checkReservation", selectedDate,
            {
            headers: {
                Authorization: new LocalStorage().authToken
            }
            });
           return Promise.resolve(response.data.data);
        } catch(error) {
            console.log("catch error : "+JSON.stringify(error));
        }
        
    }
    async getHolidayList(selectedStateCode: any) {
        let response = await axios.post(config.api.host + "/holiday", selectedStateCode, 
        {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        });
        return Promise.resolve(response.data.data);
    }

    async addHolidayInStationWorkHoliday(addHolidayData: any) : Promise<void> {
        let holidayData = {
            stationId: addHolidayData.stationId,
            holidayId: addHolidayData.holidayId,
            year: moment(addHolidayData.holidayDate).format('YYYY'),
            state: addHolidayData.state,
            holidayName: addHolidayData.holidayName,
            date: moment(addHolidayData.holidayDate).format('YYYY/MM/DD'),
            fulldayHoliday: addHolidayData.fulldayHoliday,
            startTime: (addHolidayData.formData.startTime != '' && addHolidayData.formData.startTime != '00:00:00' && new Date(addHolidayData.formData.startTime).getDate()) ? moment(addHolidayData.formData.startTime).format('HH:mm:ss') : addHolidayData.formData.startTime,
            endTime: (addHolidayData.formData.endTime != '' && addHolidayData.formData.endTime != '00:00:00' && new Date(addHolidayData.formData.endTime).getDate()) ? moment(addHolidayData.formData.endTime).format('HH:mm:ss') : addHolidayData.formData.endTime,
            status: addHolidayData.status,
            stationHolidayId: addHolidayData.stationHolidayId
        }
        let response = await axios.post(config.api.host + "/insertHoliday", {
            data: addHolidayData
        }, 
        {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        });
        let editedHolidayLIst = response.data.data;
        return Promise.resolve(editedHolidayLIst);
    }

    async deleteHoliday(deleteData: any): Promise<void> {
        let response = await axios.post(config.api.host + "/deleteHoliday", deleteData, 
        {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        });
        return Promise.resolve(response.data.data);
    }
}